/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import {
    emailChange,
    exemptionList,
    notificationPreferenceAdd,
    notificationPreferenceList,
    notificationPreferenceUpdate,
    taxFileDelete,
    taxFileList,
    taxFileUpload,
    verifyEmail,
    passwordChange,
    passwordSet,
    mobileNoChange,
    mobileNumberValid,
    resendOtp,
    verifyOtp
} from '../settings/apiconfig';
import interfaceService from './interfaceService';
import { getBuyerHeaders, getBuyersUrl } from 'shared/http';


class MyAccountService {
    constructor() {
        this.service = interfaceService.getService();
    }

    TaxFileUplaod(data) {
        return this.service.post(getBuyersUrl(taxFileUpload), JSON.stringify(data), getBuyerHeaders());
    }

    getTaxFileList() {
        return this.service.get(getBuyersUrl(taxFileList), getBuyerHeaders());
    }

    getNotificationPreference() {
        return this.service.get(getBuyersUrl(notificationPreferenceList), getBuyerHeaders());
    }

    addNotificationPreference(data) {
        return this.service.post(getBuyersUrl(notificationPreferenceAdd), JSON.stringify(data), getBuyerHeaders());
    }

    updateNotificationPreference(data) {
        return this.service.put(getBuyersUrl(notificationPreferenceUpdate), JSON.stringify(data), getBuyerHeaders());
    }

    deleteTaxExemptionFile(data) {
        return this.service.delete(getBuyersUrl(taxFileDelete), getBuyerHeaders(true, 'json', data));
    }

    getExemptionList(data) {
        return this.service.post(getBuyersUrl(exemptionList), JSON.stringify(data), getBuyerHeaders());
    }

    verifyNewEmail() {
        return this.service.get(getBuyersUrl(verifyEmail), getBuyerHeaders());
    }

    saveNewEmail(data) {
        return this.service.put(getBuyersUrl(emailChange), JSON.stringify(data), getBuyerHeaders());
    }

    changePassword(data) {
        return this.service.post(getBuyersUrl(passwordChange), JSON.stringify(data), getBuyerHeaders());
    }

    setPassword(data) {
        return this.service.post(getBuyersUrl(passwordSet), JSON.stringify(data), getBuyerHeaders(false));
    }

    changeMobile(data) {
        return this.service.put(getBuyersUrl(mobileNoChange), JSON.stringify(data), getBuyerHeaders());
    }
    mobileNumberValidate(data) {
        return this.service.post(getBuyersUrl(mobileNumberValid), JSON.stringify(data), getBuyerHeaders());
    }

    resendOtp(data) {
        return this.service.post(getBuyersUrl(resendOtp), JSON.stringify(data), getBuyerHeaders());
    }

    verifyMobile(data) {
        return this.service.get(getBuyersUrl(`${verifyOtp}${data}`), getBuyerHeaders());
    }
}

export default new MyAccountService();